import {WSPIconName, WSPIcons} from '@mintdata-wsp/resources/icons/WSPIcons';
import {Type} from '@mintdata/mint-kit/api/types/Type';

export class DataTypeIconMap
{
    public static iconNameFor(type:Type):WSPIconName
    {
        const dataTypes = WSPIcons.visualDesigner.dataTypes;

        if( Type.Boolean.isEqualTo(type) )
            return dataTypes.Boolean;
        else if( Type.Byte.isEqualTo(type) )
            return dataTypes.Byte;
        else if( Type.Integer.isEqualTo(type) )
            return dataTypes.Integer;
        else if( Type.Number.isEqualTo(type) )
            return dataTypes.Number;
        else if( Type.String.isEqualTo(type) )
            return dataTypes.String;
        else if( Type.Currency.isEqualTo(type) )
            return dataTypes.Currency;
        else if( Type.Date.isEqualTo(type) )
            return dataTypes.Date;
        else if( Type.DateTime.isEqualTo(type) )
            return dataTypes.DateTime;
        else if( Type.StringEnum.isEqualTo(type) )
            return dataTypes.StringEnum;
        else if( Type.IntegerEnum.isEqualTo(type) )
            return dataTypes.IntegerEnum;
        else if( Type.BinaryData.isEqualTo(type) )
            return dataTypes.BinaryData;
        else if( Type.Frame.isEqualTo(type) )
            return dataTypes.Frame;
        else if( Type.Error.isEqualTo(type) )
            return dataTypes.Error;
        else if( Type.Empty.isEqualTo(type) )
            return dataTypes.Empty;
        else
        {
            console.log(`Error: iconNameFor(): unknown data type: ${type}`, type);
            return null;
        }
    }
}
